import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import 'src/index.css';
import SignIn from 'src/components/SignIn/SignIn';
import Dashboard from 'src/components/Dashboard/Dashboard';
import { useAuthStore } from 'src/store/auth';
import { RoleType } from 'src/constants';

const App: React.FC = () => {
  const { isAuthenticated, fetchMeOnce, user } = useAuthStore();
  useEffect(() => {
    if (!user) {
      fetchMeOnce();
    }
  }, [user]);

  if (!isAuthenticated) {
    return <SignIn />;
  }

  if (user && user.role < RoleType.Admin) {
    return <>401</>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/underwriting" replace />} />
        <Route path="/underwriting" element={<Dashboard />} />
        <Route path="/underwriting/:underwritingId" element={<Dashboard />} />
        <Route path="/id-cards" element={<Dashboard />} />
        <Route path="/members" element={<Dashboard />} />
        <Route path="/members/:memberId" element={<Dashboard />} />
        <Route path="/groups" element={<Dashboard />} />
        <Route path="/groups/:groupId" element={<Dashboard />} />
        <Route path="/admin-groups" element={<Dashboard />} />
        <Route path="/admin-groups/:groupId" element={<Dashboard />} />
        <Route path="/admins" element={<Dashboard />} />
        <Route path="/admins/:adminId" element={<Dashboard />} />
        <Route path="/admins/create" element={<Dashboard />} />
        <Route path="*" element={<Navigate to="/underwriting" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
